import { defineStore } from 'pinia'
import { fetchUserInfo } from '@/api/projectCenter/user'
import common from '@/utils/common'
import { vipLogin,fetchContractRead,fetchPendingCount,fetchPanMajorbioData } from '@/api/common'
import Cookies from 'js-cookie'

type TCount = {
  noticeCount: number;
  projectAllCount: number;
  reportCount: number;
  originCount: number;
}

interface IUserState {
  userInfo: any,
  vipToken: string | null,
  contractStr: string,
  businessId:number | null,
  hasUnconfirmed:boolean, // 是否有未确认的原始数据
  countObj: Partial<TCount>,

}

let timer:any = null
let timer1:any = null
let timer2:any = null

export const useUserStore = defineStore('user', {
  state: (): IUserState => {
    return {
      userInfo: {}, // 用户基本信息
      vipToken: '', // 新vip系统的token
      contractStr: '', // 合同确认弹窗的字符串信息，用于展示给用户看
      businessId: null, // 业务ID
      hasUnconfirmed:false, // 是否有未确认的原始数据
      countObj: {  // 提醒数量
        noticeCount: 0, // 我的事项
        projectAllCount:0, // 项目总览
        reportCount: 0, // 线下报告
        originCount: 0, // 原始数据
      },
    }
  },
  actions: {
    setContractStr(contractStr:string) { 
      this.contractStr = contractStr
    },
    clearVipToken() { 
      this.vipToken = null
    },
    
    // 设置用户信息
    setUserInfo() {
      fetchUserInfo({}).then((res: any) => {
        let { code, data } = res
        if (code === 0) {
          let { user_info } = data
          this.userInfo = user_info
          if (common.getWebName() === 'mj' || common.getWebName() === 'local') {  // 美吉平台
            let { ypt_type, mappings } = user_info
            user_info.member_type = ypt_type
            for (let item in mappings) {
              console.log(1111, mappings[item])
              if (mappings[item].tp === 2) {
                user_info.user_id = mappings[item].pk
                break
              }
            }
          } else if (common.getWebName() === 'sg') {  // 桑格平台 
            console.log('后期处理')
            let { ypt_type, mappings } = user_info
            user_info.member_type = ypt_type
            for (let item in mappings) {
              console.log(1111, mappings[item])
              if (mappings[item].tp === 2) {
                user_info.user_id = mappings[item].pk
                break
              }
            }
          }
          


          // mock数据
          // user_info.user_id = 44467
          // user_info.member_type = 2
          // mock数据结束

          common.setCache('user', user_info)
          !common.getCache('vip-token') && this.vipLoginFunc(user_info)


          // 区分美吉、桑格
          const {
            VITE_APP_MJ_CLOUD_ORIGIN,
            VITE_APP_SG_CLOUD_ORIGIN,
            VITE_APP_MJ_KF_ORIGIN,
            VITE_APP_SG_KF_ORIGIN
                    } = import.meta.env

          let cloudOrigin = ''
          let staticUrl = ''
          

          if (common.getWebName() === 'mj' || common.getWebName() === 'local') {
            cloudOrigin = VITE_APP_MJ_CLOUD_ORIGIN
            staticUrl = VITE_APP_MJ_KF_ORIGIN
          } else if (common.getWebName() === 'sg') {
            cloudOrigin = VITE_APP_SG_CLOUD_ORIGIN
            staticUrl = VITE_APP_SG_KF_ORIGIN


          }
          let version = ''
          console.log(11111111,import.meta.env.VITE_APP_ENV)
          if (import.meta.env.VITE_APP_ENV === 'production' || import.meta.env.VITE_APP_ENV === 'flex' || import.meta.env.VITE_APP_ENV === 'staging') {
            version = '36'
          } else { 
            version = '36'
          }
          // 概览、项目总览、任务总览、回收站、我的工具任务、项目数据、工具数据、我的收藏这些模块显示websocket弹窗
          // 白名单
          const wsPopupPaths = [
            'project-center/overview',
            'project-center/report/project-overview',
            'project-center/report/task',
            'project-center/report/recycle',
            'project-center/tool-task',
            'project-center/data/project-data',
            'project-center/data/tool-data',
            'project-center/my-favorite'
          ];
          const shouldShowWsPopup = wsPopupPaths.some(path => 
            window.location.pathname.includes(path)
          );
          if (shouldShowWsPopup) {
            // 加载云平台websocket资源
            common.loadScript(cloudOrigin + '/Public/js/ws-notice/ws-notice.js?v=' + version, function () {
        
            });
          } else { 
            if (document.getElementById('pop-msg-prompt')) {
              document.getElementById('pop-msg-prompt').style.display = "none"
            }
          }

          // 项目总览、项目数据、工具数据这些模块加载迅雷SDK
          // 白名单
          const thunderPaths = [
            'project-center/report/project-overview',
            'project-center/data/project-data',
            'project-center/data/tool-data',
          ];
          const loadThunderSDK = thunderPaths.some(path => 
            window.location.pathname.includes(path)
          );
          if (loadThunderSDK) {
            // 加载迅雷SDK资源
            common.loadScript(cloudOrigin + '/v2/static/js/project_center/file/thunder-link.js?v=' + version, function () {
        
            });
          }
        }
      })
    },
    // 新vip登录接口调用
    vipLoginFunc() {
      let params:any = {
        sso: Cookies.get('sso'),
      }
      if (common.getWebName() === 'mj' || common.getWebName() === 'local') {  // 美吉平台
        params.enterprise = 1
      } else if (common.getWebName() === 'sg') {  // 桑格平台
        params.enterprise = 2
      }

      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        vipLogin(params).then((res: any) => {
          let { code, data, message } = res
          if (code === 0) {
            this.vipToken = data.token // 设置token到缓存中，首次获取时比下面的storage方式获取更快，更方便
            console.log('登录成功，token存入pinia', this.vipToken)
            common.setCache('vip-token', data.token)
            console.log('最新的sso：',Cookies.get('sso'))
            console.log('最新的vip-token：',data.token)
            this.getChContractRead()
            this.getPendingCount()
          } else {
            alert(message)
          }
        })
      }, 500)

     
    
    },
    // 获取 未确认的 VIP客户中心 推送的合同立项消息
    getChContractRead() {
      if (timer2) {
        clearTimeout(timer2)
      }
      timer2 = setTimeout(() => {
        fetchContractRead({}).then((res: any) => {
          let { code, data } = res
          if (code === 0) {
            let { info, id } = data
            
            if (id) {
              let { sn, productName, analysisTypeName } = info
              let partyAContact = this.userInfo.real_name
              this.businessId = id
              this.contractStr = `${sn}-${partyAContact}-${productName}-${analysisTypeName}`
              // Cookies.set('contractReadVisible', '0')
            }
          }
        })
      }, 500)
    },

    // 检查网盘数据是否下载/原始数据未下载
    getPanMajorbioData() {
      if (timer1) {
        clearTimeout(timer1)
      }
      timer1 = setTimeout(() => {
      fetchPanMajorbioData({}).then((res: any) => {
          let { code, data } = res
          if (code === 0) {
            let { hasUnconfirmed } = data
            this.hasUnconfirmed = hasUnconfirmed
            if (hasUnconfirmed) {
              return
            } else {
              console.log('删除cookie2')
              Cookies.remove('panMajorbioVisible')
              
            }
          }
        })
      }, 500)
        
    },

    setCount(stateData: Partial<TCount> ) { // 提醒数量（我的事项、项目总览、线下报告、原始数据）
      this.countObj = Object.assign(this.countObj, stateData) 
    },
    // 获取 未确认的 VIP客户中心 推送的合同立项消息
    getPendingCount() {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        fetchPendingCount({}).then((res: any) => {
          let { code, data } = res
          if (code === 0) {
            let { businessPendingCount, offlineReportPendingCount, releaseDataPendingCount } = data
            this.countObj['noticeCount']= businessPendingCount
            this.countObj['reportCount']= offlineReportPendingCount
            this.countObj['originCount']= releaseDataPendingCount
          }
        })
      }, 500)

      
    }
  }
})
